export default __webpack_public_path__ + "static/media/elephant.a915843a.png";